import React from 'react'
import './Footer.css'

export default function Footer() {
    return (
        <div className='footer'>
            <div className='footer-infor'>
                <h4>Our Address</h4>
                Khu đô thị FPT Hồ Chí Minh<br />
                📞:+84023111111<br />
                ☎+852 8765 4321 <br />
                ✉fptudn@.fpt.edu.vn
            </div>
            <p className='copyright'>Copyright 2024</p>
        </div>
    )
}
